/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Create_TitleInputs */

const en_admin_user_create_title = /** @type {(inputs: Admin_User_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create user`)
};

const de_admin_user_create_title = /** @type {(inputs: Admin_User_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer anlegen`)
};

/**
* | output |
* | --- |
* | "Create user" |
*
* @param {Admin_User_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_create_title = /** @type {((inputs?: Admin_User_Create_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Create_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_create_title(inputs)
	return en_admin_user_create_title(inputs)
});